module.exports = __webpack_public_path__ + "static/media/sand_card.c908e300.jpg";